import clsx from 'clsx';
import { ReactElement } from 'react';

export interface DecisionTreeContainerProps {
  children?: React.ReactNode;
}

export const DecisionTreeContainer = ({
  children,
}: DecisionTreeContainerProps): ReactElement => {
  return (
    <div
      data-testid={'schedule-visit-eligibity-container'}
      className={
        'relative flex h-full flex-col justify-between lgTablet:rounded-lg'
      }
    >
      <div className={clsx('mt-2 overflow-y-auto')}>
        <div
          className={
            'px-6 pb-[60px] pt-20 tablet:px-16 lgTablet:rounded-t-lg desktop:px-12'
          }
        >
          {children}
        </div>
      </div>
    </div>
  );
};
